// extracted by mini-css-extract-plugin
export default {"text":"CalendarIntegrationPage_text__J-PyO"};